import React, { useState } from "react";
import {
    Grid,
    InputLabel,
    Typography,
    FormHelperText,
    RadioGroup,
    FormControlLabel,
    Radio,
    TextField,
    Button,
    InputAdornment,
    IconButton,
    Box,
} from "@mui/material";
import { Formik } from "formik";
import { MainCard } from "../../../components/surface/MainCard";
import { SectionBox } from "../../../components/surface/SectionBox";
import WarrantyClaimEditing from "./WarrantyClaimEditing";
import { WarrantyClaimDTO } from "../../../models/WarrantyClaimManagement";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { apiStore } from "../../../api/ApiFactory";
import { useNavigate } from "react-router-dom";

const ClaimCreate = () => {
    const [isPopupOpen, setPopupOpen] = useState<boolean>(false);
    const [showClaimEditing, setShowClaimEditing] = useState<boolean>(false);
    const [hinNum, setHinNum] = useState('');
    const [warrantyClaim, setWarrantyClaim] = useState<WarrantyClaimDTO | null>(null);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const handleCreatePreAuth = (row: any) => {
        navigate(`/warranty/preauth/create`);
    }   

    const handleViewPreAuth = (row: any) => {
        navigate(`/warranty/preauth`);
    }   

    const handleHinSearch = () => {
        if (!hinNum) {
            setErrorMessage('HIN # is required.');
        }
        else if (hinNum.length >= 6) {
            setPopupOpen(true);
            const queryParams: { hin?: string } = hinNum ? { hin: hinNum } : {};
            apiStore.warrantyclaimApi
                .getDetailsByHin(queryParams)
                .then((res: any) => {

                    if (!res || Object.keys(res).length === 0) {
                        setErrorMessage('No record found for the provided HIN #.');
                        setShowClaimEditing(false);
                    } else {
                        setWarrantyClaim(res);
                        setShowClaimEditing(!!res);
                        setErrorMessage(''); 
                    }
                })
                .catch((error: any) => {
                    console.error(error);
                    
                    if(error.errors && error.errors[""] !== undefined) {
                        setErrorMessage(error.errors[""][0]);
                    }
                    else {
                        setErrorMessage('An error occurred while fetching the data.'); 
                    }
                    
                    setShowClaimEditing(false);
                });
        }
        else {
            setErrorMessage('Please enter at least 6 characters to perform a search.');
            setShowClaimEditing(false);
        }
    };

    return (
        <>
            <Formik
                initialValues={{ record: { preAuthorization: '', hinNum: '' } }}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(false);
                }}
                enableReinitialize
            >
                {({ errors, handleSubmit, getFieldProps, values }) => (
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                {!warrantyClaim && (
                                    <MainCard title="HIN Lookup" divider>                                        
                                        <Box>
                                                <SectionBox>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12}>
                                                            <InputLabel htmlFor="record.hinNum" sx={{ fontWeight: 'bold' }}>HIN #</InputLabel>
                                                            <TextField
                                                                disabled={false}
                                                                size="small"
                                                                fullWidth
                                                                placeholder="#HIN"
                                                                value={hinNum}
                                                                onChange={(e) => setHinNum(e.target.value)}
                                                                aria-label="Dealer Comment"
                                                                sx={{ width: '400px' }}
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <IconButton onClick={handleHinSearch} edge="end">
                                                                                <ArrowForwardIcon />
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            />
                                                            {errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>}
                                                        </Grid>
                                                    </Grid>
                                                </SectionBox>                           
                                        </Box>
                                    </MainCard>
                                )}                                
                                
                            </Grid>
                        </Grid>
                    </form>

                )}
            </Formik>
            {showClaimEditing && warrantyClaim && (
                <WarrantyClaimEditing claim={warrantyClaim} />
            )}           
        </>
    );
};

export default ClaimCreate;
